import React from "react";
import { useParams } from "react-router-dom";

const ShortURLShare = () => {
	const { id, token: shorttoken } = useParams();

	React.useEffect(() => {
		let cancelled = false;

		async function resolveAndRedirect() {
			if (!id || !shorttoken) return;

			try {
				const res = await fetch(
					`${process.env.REACT_APP_SERVER_URL}Account/GetLongUrl`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify(shorttoken),
					},
				);

				if (!res.ok) {
					const txt = await res.text().catch(() => "");
					throw new Error(`GetLongUrl falhou (${res.status}): ${txt}`);
				}

				const data = await res.json();

				// SvcResultExpires<string> -> data.data = longtoken
				const longtoken = data?.data;

				if (cancelled) return;

				if (!longtoken) {
					throw new Error(data?.message || "GetLongUrl não devolveu longtoken");
				}

				setTimeout(() => {
					window.location.href = `/account/share/${id}/${longtoken}`;
				}, 1500);
			} catch (err) {
				console.error(err);
			}
		}

		resolveAndRedirect();

		return () => {
			cancelled = true;
		};
	}, [id, shorttoken]);

	return <div style={{ display: "flex", height: "100%" }}>LOADING</div>;
};

export default ShortURLShare;
